import styled from "@emotion/styled";

export const StyledIcon = styled.img`
	height: 45px;
	width: auto;
	margin-left: -5px;
`;
